import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Media from 'sb-media'
import { useEffect } from 'sb-hooks'
import array from 'common/helpers/primitives/array'
import sentry from 'common/helpers/analytics/sentry'


import Picture from 'components/ui/Picture/Picture'

import s from './Image.scss'


const Image = (props) => {
  const { className, alt, src, w, h, mW, mH, onError, dataTestId, itemProp } = props

  if (w && h) {
    console.error('Only one property "w" or "h" allowed! Passed both!')
  }

  useEffect(() => {
    if (!src) {
      sentry.captureException('Missed "src" value', {
        extra: {
          props,
          placement: 'Image component',
        },
      })
    }
  }, [ src ])

  return (
    <Media mobile>
      {
        (isMobile) => {
          const key           = Boolean(w) ? 'w' : 'h'
          const desktopValue  = w || h
          const value         = isMobile ? mW || mH || desktopValue : desktopValue

          // If the value is not specified then show warning
          if (!value) console.warn(`Add w or h for ${src}`)

          const srcSet = src ? (
            array.range(1, 3)
              .map((count, index) => {
                const query = value ? `?${key}=${value * count}` : ''
                const link  = `${src}${query}`
                return !index ? link : `${link} ${index + 1}x`
              })
          ) : []

          const imgClassName = cx({
            [s.vertical]: Boolean(h),
            [s.horizontal]: Boolean(w),
          })

          return (
            <Picture
              className={className}
              imgClassName={imgClassName}
              src={srcSet[0]}
              srcSet={srcSet.join(', ')}
              alt={alt}
              onError={onError}
              itemProp={itemProp}
              dataTestId={dataTestId}
            />
          )
        }
      }
    </Media>
  )
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  w: PropTypes.number,
  h: PropTypes.number,
  mW: PropTypes.number,
  mH: PropTypes.number,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onError: PropTypes.func,
  itemProp: PropTypes.string, // microdata
}


export default Image
